import { Injectable } from "@angular/core";
import { AUTH_KEYS, AuthProvider, AuthResponse, LoginType } from "../../interfaces/auth-response";
import { from, map, Observable, of, tap } from "rxjs";
import { MsalService } from '@azure/msal-angular';

@Injectable({ providedIn: 'root' })
export class EntraIdProvider implements AuthProvider {

    constructor(private msalService: MsalService) { }

    login(): Observable<any> {
        return this.msalService.loginPopup().pipe(
            map(res => {
                // Imposto l'account appena loggato come attivo (se no il getToken() torna null)
                this.msalService.instance.setActiveAccount(res.account); 
                // return {
                //     accessToken: res.accessToken,
                //     expiresAt: res.expiresOn!.getTime(),
                // };
                // MSAL gestisce il refresh internamente via cache
            }),
            tap(() => localStorage.setItem(AUTH_KEYS.LOGIN_TYPE, LoginType.ENTRA_ID))
        );
    }

    getToken(): Observable<string | null> {
        const account = this.msalService.instance.getActiveAccount();
        if (!account) return of(null);

        return from(this.msalService.instance.acquireTokenSilent({
            scopes: ['user.read'],
            account: account
        })).pipe(map(res => res.accessToken));
    }

    isLoggedIn(): Observable<boolean> {
        const accounts = this.msalService.instance.getAllAccounts();
        return of(accounts.length > 0);
    }

    logout(): void { this.msalService.logoutRedirect(); }
}